import React, { useEffect } from "react";
import ServiceCard from "./ServiceCard";
import { IDoctor, Service } from "../../../../dto/interfaces";
import { listConsultationTypes } from "../../../../network/api/users/appointmentType/appointmentType";

interface DoctorProfileParams {
    doctor: IDoctor;
}

const ServicesSection: React.FC<DoctorProfileParams> = ({ doctor }) => {
    const [services, setServices] = React.useState<Service[]>([]);

    useEffect(() => {

        (async () => {
            if (doctor && doctor.id) {
                const res = (await listConsultationTypes(doctor.id)) as Service[];
                setServices(res);
            }
        })();
    }, []);
    return (
        <section id="services" className="py-16 md:py-24 bg-gray-50">
            <div className="container mx-auto px-6">
                {/* Title Block */}
                <div className="text-center mb-12 max-w-3xl mx-auto">
                    <span className="text-sm font-semibold text-gray-600 uppercase tracking-wider">Services</span>
                    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-2 mb-4">Comprehensive</h2>
                    <p className="text-lg text-gray-700">
                        Discover expert guidance for a healthier mind and balanced life.
                    </p>
                </div>

                {/* Grid of Services */}
                <div className="flex flex-wrap justify-center gap-8">
                    {services.map((service) => (
                        <ServiceCard key={service.id} service={service} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
